import React from "react";
import Loading from "../../components/shared/loading/Loading";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";
import ServiceCard from "./ServiceCard";

const ServiceListPage = () => {
  const { serviceListApi } = apiPath;
  const [homeServiceList, homeServiceListLoading] = useFetch(
    serviceListApi,
    true
  );

  if (homeServiceListLoading) {
    return <Loading />;
  }
  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {homeServiceList.map((service, idx) => (
          <ServiceCard key={idx} service={service} />
        ))}
      </div>
    </div>
  );
};

export default ServiceListPage;
